// extracted by mini-css-extract-plugin
export default {"alertBox":"maintenanceReport_alertBox__ZBJO8"};